import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import useCreateCarrier from './queries/useCreateCarrier';

import FormBase from '@/components/forms/new/FormBase';
import {
    breadCrumbTrail,
    addHeader as header,
    initialState,
    carriersPath,
} from './constants';
import CarrierNameField from './formFields/CarrierNameField';

const CarriersAdd = () => {
    const navigate = useNavigate();
    const { darkMode } = useSelector((state) => state.settings);

    const handleSuccess = () => {
        toast.success('Carrier created successfully!');
        navigate(carriersPath);
    };

    const handleError = (error) => {
        console.error('Failed to create carrier:', error);
        toast.error('Failed to create carrier. Please try again.');
    };

    const { mutate: createCarrier, isPending } = useCreateCarrier(
        handleSuccess,
        handleError,
    );

    const finalFormSubmit = async (values) => {
        if (!values.name || values.name.length < 2) {
            console.error(
                'Carrier name is required and must be at least 2 characters',
            );
            return;
        }

        createCarrier({ name: values.name });
    };

    const formFields = (errors, touched) => [
        <CarrierNameField
            key="name"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    return (
        <FormBase
            isSubmitDisabled={isPending}
            isLoading={isPending}
            breadCrumbTrail={breadCrumbTrail}
            header={header}
            initialValues={initialState}
            finalFormSubmit={finalFormSubmit}
            backLink={[carriersPath, { state: { index: 0 } }]}>
            {({ errors, touched }) => formFields(errors, touched)}
        </FormBase>
    );
};

export default CarriersAdd;
